import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { UserRound } from "lucide-react";

import { cn } from "src/lib/utils";

function Avatar({ className, ...props }) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(
        "relative flex size-8 shrink-0 overflow-hidden rounded-full",
        className
      )}
      {...props}
    />
  );
}

function AvatarImage({ className, ...props }) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn("aspect-square size-full", className)}
      referrerPolicy="no-referrer"
      {...props}
    />
  );
}

function AvatarFallback({ className, ...props }) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(
        "bg-muted flex size-full items-center justify-center rounded-full",
        className
      )}
      {...props}
    />
  );
}

function UserAvatar({
  user,
  className,
  fallbackIcon: FallbackIcon = UserRound,
}) {
  return (
    <Avatar className={className}>
      <AvatarImage src={user?.picture} alt="Profile picture" />
      <AvatarFallback>
        {user?.name ? (
          user.name
            .toUpperCase()
            .split(" ")
            .slice(0, 2)
            .map((n) => n[0])
            .join("")
        ) : (
          <FallbackIcon className="text-muted-foreground size-4" />
        )}
      </AvatarFallback>
    </Avatar>
  );
}

export { Avatar, AvatarFallback, AvatarImage, UserAvatar };
